import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const NavigationBar = () => {
  const [hoveredCategory, setHoveredCategory] = useState(null);

  const categories = [
    {
      name: 'MANGA',
      megaMenu: {
        genres: ['Shōnen', 'Shōjo', 'Seinen', 'Kodomo', 'Ver todo →'],
        publishers: ['Panini', 'Planeta', 'Milky Way', 'Norma', 'ECC'],
        series: ['One Piece', 'Naruto', 'Bleach', 'Jujutsu Kaisen', 'Chainsaw Man'],
        featured: {
          image: 'https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?w=300&h=400&fit=crop',
          title: 'Producto del mes',
          price: 8.95
        }
      }
    },
    {
      name: 'CÓMICS',
      megaMenu: {
        genres: ['Marvel', 'DC Comics', 'Image', 'Dark Horse', 'Ver todo →'],
        publishers: ['Panini', 'ECC', 'Norma', 'Dolmen', 'Astiberri'],
        series: ['Spider-Man', 'Batman', 'X-Men', 'The Walking Dead', 'Invincible'],
        featured: {
          image: 'https://images.unsplash.com/photo-1612036782391-e55e16f08c3a?w=300&h=400&fit=crop',
          title: 'Cómic destacado',
          price: 12.95
        }
      }
    },
    {
      name: 'ARTBOOKS',
      megaMenu: {
        genres: ['Anime', 'Videojuegos', 'Ilustración', 'Concept Art', 'Ver todo →'],
        publishers: ['Norma', 'Planeta', 'Taschen', 'Animeantof', 'Milky Way'],
        series: ['Studio Ghibli', 'Final Fantasy', 'Zelda', 'Pokemon', 'Dragon Ball'],
        featured: {
          image: 'https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=300&h=400&fit=crop',
          title: 'Artbook especial',
          price: 24.95
        }
      }
    },
    { name: 'JUEGOS' },
    { name: 'LIBROS' },
    { name: 'MERCHANDISING' }
  ];

  return (
    <nav className="hidden lg:block border-b border-border bg-background">
      <div className="container">
        <div className="flex items-center justify-center gap-8 h-14">
          {categories.map((category) => (
            <div
              key={category.name}
              className="relative"
              onMouseEnter={() => setHoveredCategory(category.name)}
              onMouseLeave={() => setHoveredCategory(null)}
            >
              <button className="flex items-center gap-1 text-sm font-medium text-foreground hover:text-primary transition-colors py-4">
                {category.name}
                {category.megaMenu && (
                  <ChevronDown className="w-4 h-4" />
                )}
              </button>

              {/* Mega Menu */}
              <AnimatePresence>
                {hoveredCategory === category.name && category.megaMenu && (
                  <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.2 }}
                    className="absolute top-full left-1/2 -translate-x-1/2 mt-0 w-[800px] bg-background border border-border rounded-lg shadow-2xl z-50"
                  >
                    <div className="grid grid-cols-4 gap-6 p-6">
                      {/* Géneros */}
                      <div>
                        <h3 className="text-sm font-semibold mb-3 text-foreground">Géneros</h3>
                        <ul className="space-y-2">
                          {category.megaMenu.genres.map((genre, idx) => (
                            <li key={idx}>
                              <a
                                href="#"
                                className="text-sm text-muted-foreground hover:text-primary transition-colors"
                              >
                                {genre}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* Editoriales */}
                      <div>
                        <h3 className="text-sm font-semibold mb-3 text-foreground">Editoriales</h3>
                        <ul className="space-y-2">
                          {category.megaMenu.publishers.map((publisher, idx) => (
                            <li key={idx}>
                              <a
                                href="#"
                                className="text-sm text-muted-foreground hover:text-primary transition-colors"
                              >
                                {publisher}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* Series Top */}
                      <div>
                        <h3 className="text-sm font-semibold mb-3 text-foreground">Series Top</h3>
                        <ul className="space-y-2">
                          {category.megaMenu.series.map((series, idx) => (
                            <li key={idx}>
                              <a
                                href="#"
                                className="text-sm text-muted-foreground hover:text-primary transition-colors"
                              >
                                {series}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* Producto destacado */}
                      <div className="bg-muted/30 rounded-lg p-4 flex flex-col">
                        <img
                          src={category.megaMenu.featured.image}
                          alt={category.megaMenu.featured.title}
                          className="w-full h-40 object-cover rounded-lg mb-3"
                        />
                        <h4 className="text-sm font-semibold mb-1">
                          {category.megaMenu.featured.title}
                        </h4>
                        <p className="text-primary font-bold mb-3">
                          €{category.megaMenu.featured.price.toFixed(2)}
                        </p>
                        <button className="mt-auto w-full px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary-hover transition-colors text-sm font-medium">
                          Ver producto
                        </button>
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default NavigationBar;